<!--页面弹窗组件-->
<template>
  <el-config-provider :locale="zhCn">
    <el-dialog
      v-model="visible"
      :title="dialogTitle"
      align-center
      draggable
      destroy-on-close
      :before-close="handleBeforeClose"
    >
      <div class="dialog-content">
        <slot></slot>
      </div>
    </el-dialog>
  </el-config-provider>
</template>
<script setup>
import { ref, watch, computed } from 'vue'
import { Close } from '@element-plus/icons-vue'
import { ElDialog, ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/css/tzsy.css'
const defaultTitle = import.meta.env.VITE_APP_NAME || '系统'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'close', 'open'])
const dialogTitle = computed(() => {
  if (props.title) {
    return `${defaultTitle}-${props.title}`
  }
  return defaultTitle
})
const visible = ref(props.modelValue)
watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val) {
    emit('open')
  }
}, { immediate: true })
watch(visible, (val) => {
  emit('update:modelValue', val)
  if (!val) {
    emit('close')
  }
})
const handleBeforeClose = (done) => {
  done()
}
</script>
<style lang="scss">
.el-dialog{
  padding: 0;
  height: auto;
  width: auto;
  overflow: hidden;
}
.el-dialog__header {
  background-color: #f7f7f7;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #dcdfe6;
  margin-right: 0;
  border-radius: 8px 8px 0 0;
  cursor: move;
  position: relative;
  padding: 0 16px;
}
.el-dialog__title{
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 31px;
  &::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    background-image: url("@/assets/images/logo.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.el-dialog__headerbtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog__body {
  flex: 1;
  padding: 0 !important;
  height: 100%;
  overflow: hidden;
}
.dialog-content {
  padding: 5px;
  overflow: hidden;
  height: 100%;
}

/* ========== 手机端响应式设计 ========== */
@media screen and (max-width: 768px) {
  .el-dialog__header {
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
  }
  .el-dialog__title {
    height: 44px;
    line-height: 44px;
    font-size: 13px;
  }
  .el-dialog__headerbtn {
    right: 12px;
    width: 28px;
    height: 28px;
  }
}

@media screen and (max-width: 480px) {
  .el-dialog__header {
    height: 40px;
    line-height: 40px;
  }
  .el-dialog__title {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
  }
  .el-dialog__headerbtn {
    right: 10px;
    width: 26px;
    height: 26px;
  }
}
</style>
